import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { ToastrModule } from 'ngx-toastr';
import { PrivacyComponent } from './privacy/privacy.component';
import { HeaderComponent } from './components/Shared/header/header.component';
import { NguCarouselModule } from '@ngu/carousel';
import {IvyCarouselModule} from 'angular-responsive-carousel';
// import { SwiperModule } from 'ngx-swiper-wrapper';

import { SwiperModule } from 'swiper/angular';
import { FooterComponent } from './components/footer/footer.component';


import {RouterModule} from '@angular/router';

import {
  MatFormFieldModule,
} from '@angular/material/form-field';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { PricingComponent } from './components/pricing/pricing.component';
import { PricebundleComponent } from './components/Shared/pricebundle/pricebundle.component';
import { TrustedComponent } from './components/Shared/trusted/trusted.component';
import { ContactusComponent } from './components/Shared/contactus/contactus.component';
import { ComingsoonComponent } from './components/comingsoon/comingsoon.component';
import { PartnersComponent } from './components/partners/partners.component';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { ContactuspageComponent } from './components/contactuspage/contactuspage.component';
import { NumbersComponent } from './components/numbers/numbers.component';
import { FlexibleComponent } from './components/flexible/flexible.component';
import { ContactSalesComponent } from './components/contact-sales/contact-sales.component';
import { BlogComponent } from './components/blog/blog.component';
import { MatTableModule } from '@angular/material/table' ;
import { TermsConditionsComponent } from './termsConditions/termsConditions.component';
import { RegistrationFormComponent } from './components/registration-form/registration-form.component';
import { ProgressComponent } from './components/progress/progress.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AddBranchComponent } from './components/registration-form/add-branch/add-branch.component';
import { RegistrationSuccessComponent } from './components/registration-form/registration-success/registration-success.component';

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    PrivacyComponent,
    TermsConditionsComponent,
    HeaderComponent,
    FooterComponent,
    PricingComponent,
    PricebundleComponent,
    TrustedComponent,
    ContactusComponent,
    ComingsoonComponent,
    PartnersComponent,
    AboutusComponent,
    ContactuspageComponent,
    NumbersComponent,
    FlexibleComponent,
    ContactSalesComponent,
    BlogComponent,
    RegistrationFormComponent,
    ProgressComponent,
    AddBranchComponent,
    RegistrationSuccessComponent,
  ],
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    RouterModule,
    SwiperModule,
    IvyCarouselModule,
    // NguCarouselModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CommonModule,
    BrowserAnimationsModule,
    MatTableModule,
    ToastrModule.forRoot(), // ToastrModule added
    NgxLoadingModule.forRoot({
      // animationType: ANIMATION_TYPES.threeBounce,
      animationType: ngxLoadingAnimationTypes.circleSwish,
      backdropBackgroundColour: 'rgba(0,0,0,0.3)',
      fullScreenBackdrop:true,
      backdropBorderRadius: '0px',
      primaryColour: '#853CF7',
      secondaryColour: '#853CF7',
      tertiaryColour: '#FF0000'
    }),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
